import PPostersStart from './p-posters-start.vue';

export default PPostersStart;